import { PaletteMode } from '@mui/material';

export const paletteTokens = {
  primary: '#1976d2',
  secondary: '#1565c0',
};

export const getPalette = (mode: PaletteMode) => ({
  mode,
  primary: { main: paletteTokens.primary },
  secondary: { main: paletteTokens.secondary },
  background: {
    default: mode === 'light' ? '#f5f5f5' : '#121212',
    paper: mode === 'light' ? '#ffffff' : '#1e1e1e',
  },
});
